import React from 'react';
import { Header } from '@tanstack/react-table';
import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import { Box } from 'shared/components/display';

import COLORS from 'shared/styles/colors';

interface Props<T> {
  header: Header<T, unknown>;
  /** Header label or React node (already flexRendered by the caller). */
  children: React.ReactNode;
}

/**
 * Clickable wrapper around a column header. Clicking cycles asc → desc → none.
 * Shows a chevron indicator that reflects current sort state.
 */
const SortableHeader = <T,>({ header, children }: Props<T>) => {
  if (!header.column.getCanSort()) {
    return <>{children}</>;
  }

  const sortDirection = header.column.getIsSorted();
  let icon = faSort;
  let iconColor = COLORS.NEUTRAL400;
  if (sortDirection === 'asc') {
    icon = faSortUp;
    iconColor = COLORS.NEUTRAL700;
  } else if (sortDirection === 'desc') {
    icon = faSortDown;
    iconColor = COLORS.NEUTRAL700;
  }

  return (
    <Box
      className={cs('brkfst-table__sort-trigger', {
        'brkfst-table__sort-trigger--active': !!sortDirection,
      })}
      onClick={header.column.getToggleSortingHandler()}
    >
      <span>{children}</span>
      <FontAwesomeIcon
        className="brkfst-table__sort-icon"
        icon={icon}
        size="xs"
        color={iconColor}
      />
    </Box>
  );
};

export default SortableHeader;
